import type { QuizPlayersScoreData } from '@mentimeter/core-hooks';
import { useQuizResults } from '@mentimeter/quiz';
import type { QuizOpenStaticContent } from '@core-api/presentation/types/response';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { ViewOnlyPresentation } from './ViewOnlyPresentation';
import { useQuizOpenPreviewResultsLegacy } from './hooks/use-quiz-open-preview-results-legacy';

export const ViewOnlyPresentationDataHandler = () => {
  const { useConfig, InteractiveCanvasComponents, isPreviewResultsEnabled } =
    usePresentationContext();
  const { enableAnimations, readonly } = useConfig();
  const { data = [] } = useQuizResults<QuizPlayersScoreData>();

  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as QuizOpenStaticContent;
  const interactiveContent = slide.interactiveContents[0]!;

  const firstCorrectAnswer = interactiveContent.choices[0]?.title;

  const previewResults = useQuizOpenPreviewResultsLegacy({
    isPreviewResultsEnabled,
    correctAnswer: firstCorrectAnswer,
  });

  const resultsToShow = isPreviewResultsEnabled ? previewResults : data;

  return (
    <ViewOnlyPresentation
      title={slide.title}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      description={interactiveContent.description}
      visibleCorrectAnswer={firstCorrectAnswer ?? ''}
      textSizeOffset={staticContent.textSizeOffset}
      shouldAnimate={enableAnimations}
      isReadonly={readonly}
      results={resultsToShow.length > 0 ? resultsToShow : undefined}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
    />
  );
};
